import { t } from "i18next";

import IconActivity from "src/core/assets/images/radar/activity.svg?react";
import IconClient from "src/core/assets/images/radar/client.svg?react";
import IconLocation from "src/core/assets/images/radar/location.svg?react";
import IconMission from "src/core/assets/images/radar/mission.svg?react";
import { RadarChart, RadarMetric } from "src/core/components/folder/cartography/RadarChart";
import { CustomRiskLevel } from "src/core/constants/risk";
import { useCartographyRisks } from "src/core/contexts/FolderContext";

const getRiskValue = (risk: CustomRiskLevel) => {
  switch (risk) {
    case CustomRiskLevel.LOW:
      return 33;
    case CustomRiskLevel.MEDIUM:
      return 66;
    case CustomRiskLevel.HIGH:
      return 100;
    default:
      return 0;
  }
};

export const FolderRadar = ({ isOnePage = false }: { isOnePage?: boolean }) => {
  const folderRisks = useCartographyRisks();

  const data: RadarMetric[] = [
    {
      label: t("folder.cartographie.radar.location"),
      icon: IconLocation,
      value: getRiskValue(folderRisks.location),
    },
    {
      label: t("folder.cartographie.radar.client"),
      icon: IconClient,
      value: getRiskValue(folderRisks.client),
    },
    {
      label: t("folder.cartographie.radar.mission"),
      icon: IconMission,
      value: getRiskValue(folderRisks.mission),
    },
    {
      label: t("folder.cartographie.radar.activity"),
      icon: IconActivity,
      value: getRiskValue(folderRisks.activity),
    },
  ];

  return (
    <div
      className={
        !isOnePage
          ? "w-2/5 bg-background-secondary border-r border-border z-0 h-full overflow-visible"
          : ""
      }
    >
      <h2 className="flex items-center justify-center h-[50px] mx-20 mb-20 font-medium border-b border-border">
        {t("folder.cartographie.radar.title")}
      </h2>
      <RadarChart data={data} size={300} />
    </div>
  );
};
